import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider as ReduxProvider } from 'react-redux';
import store, { persistor } from './redux';
import { PersistGate } from 'redux-persist/integration/react';
import ThemeProvider from './providers/ThemeProvider';
import ApolloClientProvider from './providers/ApolloClientProvider';
import { StylesProvider } from '@mui/styles';

ReactDOM.render(
  <React.StrictMode>
    <ReduxProvider store={store}>
      <PersistGate loading={<></>} persistor={persistor}>
        <ApolloClientProvider>
          <Suspense fallback={<></>}>
            <StylesProvider injectFirst>
              <ThemeProvider>
                <App />
              </ThemeProvider>
            </StylesProvider>
          </Suspense>
        </ApolloClientProvider>
      </PersistGate>
  </ReduxProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
